"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersTableDefaultSort = [{
        dataField: 'displayName',
        order: 'asc'
    }];
//# sourceMappingURL=UsersTableDefaultSort.js.map